<template>
    <v-card color="#F4FEFB">
        <v-card-title>
            印影の設定
        </v-card-title>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <badge-component tile content="必 須" color="red">
                  <label-component>入力者</label-component>
              </badge-component>
              <v-select
                :items="selectDestinations"
                outlined
                hide-details
                v-on:change="changeUserId"
                v-model="selected"
                background-color="white"
              >
              </v-select>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
                <v-btn
                    block
                    color="red"
                    class="white--text"
                    v-on:click="selectSeal"
                    v-bind:disabled="isDisabled"
                >
                    押印
                </v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
export default {
    props: ['destinations', 'destinationId'],
    data: function () {
        return {
            selectDestinations: [],
            selected: 0,
            isDisabled: false,
        };
    },
    created: function () {
        this.selected = this.destinationId;
        Object.entries(this.destinations).forEach((val, index) => {
            this.selectDestinations.push({
                text: val[1].destination_user_name,
                value: val[1].id
            });
        });
    },
    methods: {
        selectSeal: function () {
            this.$emit('openSelectSealDialog');
        },
        changeUserId: function (e) {
            this.$emit('changeUserId', e);
        }
    }
};
</script>

<style scoped>

</style>